// extracted by mini-css-extract-plugin
module.exports = {"content":"List_content__3ilfh"};